import React from 'react';
import XMarkIcon from './icons/XMarkIcon';
import FaqItem from './FaqItem';
import { useTranslation } from 'react-i18next';
import { QuestionAnswerOption } from '@/types';

interface HelperMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

const HelperMenu: React.FC<HelperMenuProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const faqData = t('helperMenu.faq', { returnObjects: true }) as Record<string, string>;
  const faqOptions: QuestionAnswerOption[] = Object.keys(faqData)
    .filter(key => key.startsWith('q'))
    .map(qKey => parseInt(qKey.substring(1)))
    .map(num => ({ question: faqData[`q${num}`], answer: faqData[`a${num}`] }));

  if (!isOpen) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 bg-opacity-50 z-50 flex justify-center items-center p-4"
      onClick={onClose}
      aria-modal="true"
      role="dialog"
    >
      <div
        className="bg-white rounded-lg shadow-xl w-full max-w-md flex flex-col max-h-[90vh]"
        onClick={e => e.stopPropagation()}
      >
        <div className="flex justify-between items-center p-4 border-b border-slate-200 flex-shrink-0">
          <h2 className="text-lg font-bold text-slate-800">{t('helperMenu.title')}</h2>
          <button onClick={onClose} className="p-1 rounded-full hover:bg-slate-200" aria-label={t('helperMenu.closeButtonLabel')}>
            <XMarkIcon className="w-5 h-5 text-slate-600" />
          </button>
        </div>
        
        <div className="p-4 divide-y text-small text-slate-600 divide-gray-200 overflow-y-auto">
            {faqOptions.map((faq, index) => (
              <FaqItem key={index} question={faq.question} answer={faq.answer} />
            ))}
        </div>

        <div className="p-4 border-t border-slate-200 text-xs text-slate-500 flex-shrink-0">
          <p className="mb-2">{t('helperMenu.footerInfo')}</p>
          <a href={t('helperMenu.privacyPolicyLink')} target="_blank" rel="noopener noreferrer" className="text-sky-600 hover:underline">{t('helperMenu.privacyPolicy')}</a>
          <span className="mx-2">|</span>
          <a href={t('helperMenu.termsOfUseLink')} target="_blank" rel="noopener noreferrer" className="text-sky-600 hover:underline">{t('helperMenu.termsOfUse')}</a>
        </div>
      </div>
    </div>
  );
};

export default HelperMenu;
